import { http } from '../../core/services'

export const loadNotes = providerId =>
  http
    .get(`management/providers/${providerId}/notes`)
    .then(response => response.data.notes || '')

export const saveNotes = (providerId, notes) =>
  http.put(`management/providers/${providerId}/notes`, { notes })
